module.exports = __webpack_public_path__ + "img/7.faac41a1.jpg";